<template>
  <div :class="[$style.blogPostContainer, 'container']">
    <div :class="$style.back">
      <nuxt-link
        :to="localePath('/tutorial')"
        :class="$style.backIcon"
      >
        <UiIconsArrowLeft-s />
      </nuxt-link>

      <div :class="$style.backTitle">
        <slot name="preventPageTitle" />
      </div>
    </div>

    <div v-if="$slots.banner" :class="$style.topBanner">
      <slot name="banner" />
    </div>

    <div :class="$style.content">
      <h1 :class="[$style.title, 'h3']"><slot name="postTitle" /></h1>

      <section :class="[$style.main, 'text']">
        <slot name="content" />
      </section>
    </div>

    <section :class="[$style.recent, 'section container']">
      <slot name="recent" />
    </section>

    <slot name="subscr" />
  </div>
</template>

<script setup lang="ts">
const localePath = useLocalePath();
</script>

<style lang="scss" module>
  .blogPostContainer {
    padding-bottom: 32px;
  }

  .main {
    margin-top: 25px;
  }

  .title {
    margin-bottom: 6px;
  }

  .date {
    color: #71787F;
    font-size: 14px;
    margin-bottom: 25px;
  }

  .topBanner {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 26px;
    border-radius: 24px;
    overflow: hidden;
    margin-bottom: 42px;
    height: 80vh;
    max-height: 540px;

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }

  .content {
    max-width: 860px;
    margin-left: auto;
    margin-right: auto;
  }

  .back {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 35px;

    @media (max-width: 767px) {
      display: none;
    }

    &Title {
      color: #121E29;
      font-family: 'Gilroy';
      font-size: 32px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    &Icon {
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 35px;
      height: 35px;
      border-radius: 35px;
      background-color: #F8F8F8;
      color: #8D9398;
      transition: 200ms ease;

      svg {
        width: 12px;
        height: auto;
      }

      &:hover {
        opacity: .8;
      }
    }
  }
</style>